<template>
    <div class="container mt-4 mb-2 pt-2 pb-2">
     <div class="row text-md-left mt-3 pb-3 justify-content-center">
         <a v-bind:href="this.support" target="__blank">
         <div class="d-flex">
            <svg-icon aria-labelledby="question mark"  :name="this.brand+ '/question-mark'" class="mr-3 d-none d-sm-inline-block" width="64" height="auto"></svg-icon>
            <div>
                <h3 class="text-dark">Need help or want to provide feedback? </h3>
                <h2 class="underline">Visit the help center</h2>
            </div>
        </div>
         </a>

     </div>
    </div>
</template>

<script>
const whitelabel = require('../../whitelabel.config')[process.env.VUE_APP_BRAND]

export default {
    data() {
        return {
            support: whitelabel.support,
            brand: whitelabel.brand,
            ticket: whitelabel.ticket,
        }
    },
}
</script>

<style scoped >
a{
    color:#4547BF;
    text-decoration: none;
}
a:hover {
    color:#4547BF;
    text-decoration: none;
    border: 1px solid #4547BF;
}

</style>
